// api
import { fetchApi } from '@/api'
import router from '@/router'

const controlaccesoturnscreate = (context, array) => {
  let url = 'admin/crearturno'
  let data = JSON.stringify(array)
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('CONTROL_ACCESO_TURNS_TABLE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
        console.error(error)
    })
}

const controlaccesoturnslist = (context, array) => {
  let url = 'admin/mostrarturno'
  let data = JSON.stringify(array)
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('CONTROL_ACCESO_TURNS_LIST', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
        console.error(error)
    })
}

const controlaccesoturnseditar = (context, id) => {
  let url = 'admin/turns/' + id + '/edit'
  return fetchApi(url, [], 'GET')
    .then((response) => {
      console.log(response)
      context.commit('CONTROL_ACCESO_TURNS_EDIT', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
        console.error(error)
    })
}

const controlaccesoturnsupdate = (context, data) => {
  let url = 'admin/turns/' + data.id
  let json = JSON.stringify(data)
  console.log(json)
  return fetchApi(url, json, 'PUT')
    .then((response) => {
      console.log(response)
      context.commit('CONTROL_ACCESO_TURNS_EDIT', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
        console.error(error)
    })
}

const controlaccesoturnsdelete = (context, payload) => {
  let obj = JSON.parse(payload)
  alert(obj.id)
  let url = 'admin/turns/' + obj.id
  return fetchApi(url, payload, 'DELETE')
    .then((response) => {
      context.commit('ADMIN_USERS_DELETE', response)
      location.reload()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const controlaccesodelete = (context, payload) => {
  let url = 'admin/controlacceso'
  return fetchApi(url, payload, 'POST')
    .then((response) => {
      context.commit('ADMIN_USERS_DELETE', response)
      location.reload()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const controlaccesoreportsauxturn = (context, array) => true

export default {
  controlaccesoturnscreate,
  controlaccesoturnslist,
  controlaccesoturnseditar,
  controlaccesoreportsauxturn,
  controlaccesoturnsupdate,
  controlaccesoturnsdelete,
  controlaccesodelete
}



// WEBPACK FOOTER //
// ./src/store/modules/controlacceso/turns/actions.js